import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Api } from '../api.service'
import type { Feature } from '../feature'

/** Executes the sibling-user lookup and proxies the API response. */
export const executeGet = store.effects.create((feature: Feature, api: Api) =>
  feature.actions.get.request.observe().pipe(
    rxjs.switchMap(action =>
      api.get().pipe(
        rxjs.takeUntil(feature.actions.clear.observe()),
        rxjs.map(response =>
          feature.actions.get.success.from(action).create({
            request: action.data,
            response,
          }),
        ),
        rxjs.catchError((error: Error) =>
          rxjs.of(
            feature.actions.get.error.from(action).create({
              error,
              request: action.data,
            }),
          ),
        ),
      ),
    ),
  ),
)
